import { toRaw } from 'vue';
import { InternalRuleItem } from 'async-validator';
import { HtmlFormField } from '@/presentation/components/scholarship-form/html-editor/html-form-field';
import { MassSelectFormField } from '../../../presentation/components/scholarship-form/mass-select/mass-select-form-field';
import { DeadlineFormField } from '../../../presentation/components/scholarship-form/deadline-editor/deadline-form-field';
import { ProviderFormField } from '@/presentation/components/scholarship-form/provider-editor/provider-form-field';

export const htmlFormFieldCharacterLimit = (
	rule: InternalRuleItem,
	value: HtmlFormField,
	callback: (error?: string | Error) => void
): void => {
	if (!value.content && rule.required) {
		return callback('Required field');
	}

	if (rule.max !== undefined && value.numberOfCharacters > rule.max) {
		return callback(`Character limit of ${rule.max} has been reached`);
	}

	callback(undefined);
};

export const massSelect = (
	rule: InternalRuleItem,
	value: MassSelectFormField,
	callback: (error?: string | Error) => void
): void => {
	const raw = toRaw(value);

	const isSpecificSelection = raw.specific.keys.value.length > 0 && raw.specific.unmatchedInput.length === 0;

	if (rule.required && !isSpecificSelection && !raw.allSelected.value) {
		return callback('Required field');
	}

	if (raw.specific.unmatchedInput.length > 0) {
		return callback(`Following items did not match: '${raw.specific.unmatchedInput.toString()}'`);
	}

	callback(undefined);
};

export const deadline = (
	rule: InternalRuleItem,
	value: DeadlineFormField,
	callback: (error?: string | Error) => void
): void => {
	const raw = toRaw(value);

	if (rule.required && raw.noSelectionMade()) {
		return callback('Required field');
	}

	if (raw.isSpecified.value && !raw.date.value) {
		return callback('The date has not been selected');
	}

	callback(undefined);
};

export const providerSelect = (
	rule: InternalRuleItem,
	value: ProviderFormField,
	callback: (error?: string | Error) => void
): void => {
	const raw = toRaw(value);

	const providerValue = raw.provider.value;

	if(rule.required && providerValue === undefined) {
		return callback('Organisation or Body is required');
	}

	const isOrganisation = providerValue === 0;
	const isBody = providerValue === 1;

	if(rule.required && isOrganisation && !raw.providerOrganisationId.value) {
		return callback('Organisation is required');
	}

	if(rule.required && isBody && !raw.providerBodyId.value) {
		return callback('Body is required');
	}

	callback(undefined);
}